import { render, staticRenderFns } from "./communityFeeSummaryList.vue?vue&type=template&id=656c1bc4&scoped=true"
import script from "./communityFeeSummaryList.vue?vue&type=script&lang=js"
export * from "./communityFeeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./communityFeeSummaryList.vue?vue&type=style&index=0&id=656c1bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c1bc4",
  null
  
)

export default component.exports